import { DropType } from '@aboutyou/legacy-shared/src/grpc_client/grips/protos/shared/drop'
import { cdnImageUrl } from 'helpers/image'
import { DropDetailsBackButton } from 'pages/Drops/components/DropDetailsBackButton'
import { DropDetailsBrandImage } from 'pages/Drops/components/DropDetailsBrandImage'
import { StickyCountdown } from 'pages/Drops/components/StickyCountdown'
import { useDetailedDropById } from 'pages/Drops/useDetailedDropById'
import React, { FC, RefObject } from 'react'
import {
  BottomGradient,
  DropDetailsBanner as DropDetailsBannerWrapper,
  TopGradient,
} from 'uiComponents/atoms/Drops/DropDetailsBanner'
import { DropDetailsScrollDownIcon } from 'uiComponents/atoms/Drops/DropDetailsScrollDownIcon'
import { DropDetailsUsps } from 'uiComponents/atoms/Drops/DropDetailsUsps'
import { IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import ImageBox from 'uiComponents/atoms/ImageBox/ImageBox'

export const DropDetailsBanner: FC<{
  dropDetailsWrapperRef: RefObject<HTMLDivElement> | null
}> = ({ dropDetailsWrapperRef }) => {
  const detailedDropById = useDetailedDropById()

  if (!detailedDropById) {
    return null
  }
  if (!detailedDropById?.desktopImage) {
    return null
  }

  return (
    <DropDetailsBannerWrapper>
      <TopGradient />
      <DropDetailsBackButton
        isLiveShow={detailedDropById.type === DropType.DROP_TYPE_LIVE_SHOW}
      />
      <DropDetailsScrollDownIcon
        data-testid="Icon"
        size={IconSize.S}
        asset={IconName.IcScrollWhite}
      />
      <ImageBox src={cdnImageUrl(detailedDropById.desktopImage)} />
      <StickyCountdown
        drop={detailedDropById}
        dropDetailsWrapperRef={dropDetailsWrapperRef}
      />
      <DropDetailsBrandImage
        brandImage={detailedDropById?.brandImage}
        headline={detailedDropById?.headline}
        subline={detailedDropById?.subline}
      />
      <DropDetailsUsps usps={detailedDropById?.usps} />
      <BottomGradient />
    </DropDetailsBannerWrapper>
  )
}
